// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiBaseUrl:'https://csw-api.indusnettechnologies.com/',
  domain : "https://indusnettechnologies.com",
  tenant: '07976758-93c6-4bef-b3dc-538603dc916e',
  clientId: '9d5b27e3-e8ee-4d50-b0bd-6dd88f9a2456',
  redirectUri: 'https://indusnettechnologies.com',
  postLogoutRedirectUri: 'https://csw-cla.indusnettechnologies.com/',
  appBaseUrl: 'https://csw-cla.indusnettechnologies.com/',
  facilityBaseUrl: 'https://csw-api.indusnettechnologies.com/facility/',
  eventBaseUrl:'https://csw-api.indusnettechnologies.com/events/',
  vmsBaseUrl:'https://csw-api.indusnettechnologies.com/vms/',
  apiBaseUrlVegitation:'https://csw-api.indusnettechnologies.com/pms/',
  nonRfIdParks:'baaea373-d5a0-4388-ba57-57e6f5513264',
  apiBaseUrlRole:'https://csw-api.indusnettechnologies.com/user-mgnt/',
  storageEncryptionKey: '025b0dad334a595ca76d62ce72a673f1aa55dbfd692f0c113319bde766596165',
  officeRndClientId: 'CglhiTG9uTjsQYyD',
  officeRndClientSecret: 'jy9qS4XJyFjFinEYwNAolrxyzat5HxN0',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
